// components/BlogPostDetail.jsx
import React from "react";
import { Card, Typography, Divider, Space, Tag, Button } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Like from "./Like/Like";

const { Title, Paragraph } = Typography;

const BlogPostDetail = ({ post, onEdit, onDelete }) => {
  return (
    <Card
      title={
        <div>
          <Title level={2} style={{ marginBottom: 0 }}>
            {post.title}
          </Title>
          <Space size="large" style={{ marginTop: 16 }}>
            <span>
              <UserOutlined /> {post.author}
            </span>
            <span>
              <CalendarOutlined />{" "}
              {new Date(post.publishedDate).toLocaleString()}
            </span>
            <span>
              <EyeOutlined /> {post.views || 0} 阅读
            </span>
            <span>
              <Like post={post} />
            </span>
          </Space>
        </div>
      }
      extra={
        <Space>
          <Button icon={<EditOutlined />} onClick={onEdit}>
            编辑
          </Button>
          <Button icon={<DeleteOutlined />} danger onClick={onDelete}>
            删除
          </Button>
        </Space>
      }
    >
      {post.tags &&
        post.tags.map((tag) => (
          <Tag color="blue" key={tag}>
            {tag}
          </Tag>
        ))}

      <Divider />

      <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
        {post.content}
      </Paragraph>
    </Card>
  );
};

export default BlogPostDetail;
